<template>
	<div>
		<h2>{{ $t('labels.general.staff') }}</h2>
		<div class="btn-bar">
			<div>
				<router-link :to="{ name: 'UserProfileStaffStaff' }" class="btn" active-class="btn-primary">{{ $t('labels.general.staff') }}</router-link>
				<router-link :to="{ name: 'UserProfileStaffInvitations' }" class="btn" active-class="btn-primary">{{ $t('labels.general.invitations') }}</router-link>
			</div>
			<div>
				<router-link v-if="isRouteInvitations" :to="{ name: 'UserProfileStaffInvitationSendForm' }" class="btn" active-class="btn-primary">{{ $t('labels.general.send_invitation') }}</router-link>
			</div>
		</div>
		<!--keep-alive-->
			<router-view/>
		<!--/keep-alive-->
	</div>
</template>

<script>
export default {
	computed: {
		isRouteInvitations () {
			return this.$route.name === 'UserProfileStaffInvitations'
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$title('Staff')
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/Staff.vue